import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Form, Input, Button } from 'antd';
import Local from '@/common/helper/local';
import { HelpOther } from '@/common/helper';
import userStore from '@/store/user';
import store from './store';
import { INVITE_BTN_TEXT_MAP, formList, INVITE_FORM_DATA } from './constant';
const { TextArea } = Input;

import './style.scss';

const InviteForm = () => {
  // const [formData, setFormData] = useState({});
  const [form] = Form.useForm();
  const [btnDisabled, setBtnDisabled] = useState(true);
  const { mobile, safeSecMobile, relMobileNumber } = userStore.userInfo;
  const userMobile = mobile || safeSecMobile || relMobileNumber;

  const setBtnStatus = () => {
    // 当手机号和用户信息未填写时,按钮不可用
    const btnDisabled =
      form.getFieldsValue()?.mobile?.trim() &&
      form.getFieldsValue()?.user_need?.trim()
        ? false
        : true;
    setBtnDisabled(btnDisabled);
  };

  const onFinish = values => {
    // 去除每一项的首尾空格
    for (const key in values) {
      if (typeof values[key] === 'string') {
        values[key] = values[key].trim();
      }
    }

    if (!values.mobile || !values.user_need) {
      HelpOther.toast('请填完善申请信息', 'warning');
      return;
    }
    store.submit(values);
  };

  const onValuesChange = (changedValues, allValues) => {
    Local.setItem(INVITE_FORM_DATA, allValues);
    setBtnStatus();
  };

  useEffect(() => {
    const loadData = async () => {
      // 优先使用提交过的数据
      if (store?.submitedData && store.inviteStatus > 0) {
        form.setFieldsValue(store?.submitedData);
        setBtnStatus();
        return;
      }

      // 本地持久化存储的数据
      const localData = Local.getItem(INVITE_FORM_DATA) || {};
      const newFormData = userMobile
        ? { ...localData, mobile: userMobile }
        : localData;

      form.setFieldsValue(newFormData);
      setBtnStatus();
    };
    loadData();
  }, [store.submitedData, userStore.userInfo?.mobile]);

  useEffect(() => {
    if (store.inviteStatus > 0) {
      setBtnDisabled(true);
    } else {
      setBtnDisabled(false);
    }
  }, [store.inviteStatus]);

  useEffect(() => {
    store.init();
  }, []);

  // 表单不可编辑
  const formDisabled = store.inviteStatus > 0;

  return (
    <div className="invite-form w-648px p-24px bg-[#fff] rounded-24px box-border">
      <h3 className="text-24px font-bold-500 mb-0 leading-34px text-[#000]">
        深度研究智能体
      </h3>
      <div className="pt-4px pb-24px text-14px leading-20px text-black/50">
        输入您的信息，我们将尽快为您发送邀请码。同时请确认PC客户端已更新至最新版本。
      </div>

      <div className="relative">
        {!userMobile && (
          <div
            className="absolute right-0 top-0 text-[#006AFF] hover:text-opacity-80 cursor-pointer z-10"
            onClick={() => store.bindMobile()}
          >
            绑定手机号
          </div>
        )}
        <Form
          layout="vertical"
          onFinish={onFinish}
          onValuesChange={onValuesChange}
          autoComplete="off"
          // initialValues={formData}
          form={form}
          disabled={formDisabled}
        >
          {formList.map(item => (
            <Form.Item
              key={item.name}
              name={item.name}
              label={item.label}
              rules={item.rules}
              className="!mb-20px"
            >
              {item.textarea ? (
                <TextArea placeholder={item.placeholder} />
              ) : (
                <Input
                  placeholder={item.placeholder}
                  disabled={item.disabled}
                />
              )}
            </Form.Item>
          ))}

          <Form.Item label={null} className="flex justify-end !mb-0">
            <Button
              type="primary"
              htmlType="submit"
              disabled={formDisabled || btnDisabled}
            >
              {INVITE_BTN_TEXT_MAP[store.inviteStatus]}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default observer(InviteForm);
